import React from "react";
import Title from "../../ui/Title";

const FamilyStructures = () => {
  return (
    <div id="changing-family-structures" className="scroll-mt-24">
      <Title
        title="Changing family structures and its impact on caregiving"
        className="mb-6"
      />

      <div className="space-y-2 text-softBlack leading-loose text-base font-normal">
        <h3
          id="increase-long-distance-caregiving"
          className="text-xl font-bold text-black scroll-mt-24"
        >
          The increase in long-distance caregiving (remote caregiving)
        </h3>

        <p>
          The number of caregivers who are supporting their loved ones from a
          distance is also on the rise. According to{" "}
          <a
            href="https://www.nia.nih.gov/health/long-distance-caregiving"
            className="text-blue underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            information
          </a>{" "}
          from the National Institute of Aging in the United States, “if a
          person is caring for someone who lives an hour or more away, then they
          are a long-distance caregiver.”
        </p>

        <p>
          Long-distance caregiving can include financial management, planning
          and arranging hospital visits, managing medication, planning for
          emergencies, household management, and providing emotional support.
          Certain advancements in technology are also facilitating the rise in
          the number of people providing care for a loved one from a distance.
          Long-distance caregiving is often hidden and its challenges remain
          unnoticed. According to a{" "}
          <a
            href="https://cdn.shopify.com/s/files/1/0831/0430/1340/files/JubileeTV_CaregiverSurveyReport.pdf?v=1726551186"
            className="text-blue underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            survey
          </a>{" "}
          conducted by Jubilee TV, often, long-distance caregivers are hesitant
          to identify themselves as caregivers even though they are spending
          considerable time and effort on care; approximately two in five remote
          caregivers don't identify themselves as caregivers at all.
        </p>

        <p>
          Long-distance caregiving can have a significant impact on the
          caregiver’s life. According to the survey, one-third of long-distance
          caregivers spend more than 10 hours a week on caregiving, which is the
          equivalent of doing a part-time job. Due to the hidden nature of
          long-distance caregiving, the support caregivers receive is extremely
          scarce. There is a dire need to recognize long-distance caregivers and
          create support systems that suit their needs. It is also important
          that efforts are taken in order for workplaces to recognize and
          understand the challenges of remote caregivers, and provide
          flexibility to accommodate their needs.
        </p>

        <p className="italic">
          Here are more statistics that highlight the toll long-distance
          caregiving can take on the caregiver’s lives:
        </p>

        <div className="flex flex-col items-center gap-2">
          <div className="!mt-6">
            <img
              src="/assets/img/jubilee-tv.png"
              alt="The Social & Emotional Toll - Statistics from Jubilee TV Caregiver Survey"
            />
          </div>

          <p>
            <a
              href="https://cdn.shopify.com/s/files/1/0831/0430/1340/files/JubileeTV_CaregiverSurveyReport.pdf?v=1726551186"
              className="text-blue underline italic"
              target="_blank"
              rel="noopener noreferrer"
            >
              Source: Jubilee TV - Caregiver Survey report
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default FamilyStructures;
